module.exports = __webpack_public_path__ + "static/media/tooltip.d38eb66c.svg";